export default "__VITE_ASSET__BcdUgL9O__"